import { logRumAction } from 'lib/DDRum';

const CHANNEL_NAME = 'aqua-client-auth';
const LOGOUT_EVENT_TYPE = 'logout';

const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : null;

export const registerLogoutListener = (handler) => {
  if (!channel) {
    return;
  }
  channel.onmessage = (event) => {
    if (event.data?.type === LOGOUT_EVENT_TYPE && typeof handler === 'function') {
      logRumAction('broadcast logout message received');
      handler();
    }
  };
};

export const closeAuthChannel = () => {
  channel?.close();
};

export const broadcastLogout = () => {
  channel?.postMessage({ type: LOGOUT_EVENT_TYPE });
};
